import React, { useContext, useState } from 'react';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { Timeout, formattedDate } from '../../functions/functions';
import { FormDiplomsContext, ShowDiplomsContext } from './types';
import InputsDiploms from './forms/InputsDiploms';
import { useDispatch } from 'react-redux';
import { AddDiplomApi } from '../../redux/diploms/diplomApiCalls';
import { useParams } from 'react-router';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean,
  toggle: any,
}

const AddDiplomModal: React.FC<props> = ({ modal, toggle }) => {
  const [title, setTitle] = useState("")
  const [image, setImage] = useState<File | any>(null)
  const [faculty, setFaculty] = useState("")
  const [period, setPeriod] = useState("")
  const [dateOfGraduation, setDateOfGraduation] = useState(formattedDate(new Date().toString()))
  const [type, setType] = useState("")
  const [yearsOfSuccessfulStudy, setYearsOfSuccessfulStudy] = useState("")
  const [placeOfGraduation, setPlaceOfGraduation] = useState("")

  const dispatch: any = useDispatch()
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])

  const { doctorId } = useParams()

  const { setShowSuccessMsg } = useContext(ShowDiplomsContext)

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData: any = new FormData()
      formData.append("title", title)
      formData.append("image", image)
      formData.append("faculty", faculty)
      formData.append("period", period)
      formData.append("dateOfGraduation", dateOfGraduation)
      formData.append("placeOfGraduation", placeOfGraduation)
      formData.append("type", type)
      formData.append("yearsOfSuccessfulStudy", yearsOfSuccessfulStudy)
      const response: any = await dispatch(AddDiplomApi(formData, doctorId))

      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        setTitle("")
        setFaculty("")
        setPeriod("")
        setDateOfGraduation(formattedDate(new Date().toString()))
        setType("")
        setYearsOfSuccessfulStudy("")
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormDiplomsContext.Provider value={{
      title, setTitle,
      image, setImage,
      faculty, setFaculty,
      type, setType,
      period, setPeriod,
      dateOfGraduation, setDateOfGraduation,
      yearsOfSuccessfulStudy, setYearsOfSuccessfulStudy,
      placeOfGraduation, setPlaceOfGraduation
    }}>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full p-4 mx-auto bg-white rounded-md shadow-lg" style={{ width: "600px" }}>
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType='multipart/form-data'
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsDiploms />
                    <ButtonsForm loading={loading} typeBtn='Ajouter' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </FormDiplomsContext.Provider>
  );
}

export default AddDiplomModal
